export const CELEBRATION_POINTS_HELP_URL =
  'https://kudosng.zendesk.com/hc/en-us/articles/38840889061133-How-to-allocate-points-for-celebrations-and-milestones'
export const POINT_BANKS_HELP_URL =
  'https://kudosng.zendesk.com/hc/en-us/articles/38840934003213-How-to-create-and-manage-point-banks'
export const PEER_TO_PEER_POINTS_HELP_URL =
  'https://kudosng.zendesk.com/hc/en-us/articles/38840831493133-How-to-allocate-peer-to-peer-points-for-recognition'
export const POINTS_PREFERENCES_HELP_URL =
  'https://kudosng.zendesk.com/hc/en-us/articles/38839659485069-How-to-configure-point-preferences'
export const SECURITY_HELP_URL =
  'https://kudosng.zendesk.com/hc/en-us/articles/38786775345293-How-to-configure-security-and-access-settings'
